import moment from 'moment'

export enum DateFormat {
  SIMPLE_FORMAT = 'DD/MM/YYYY',
  SIMPLE_DATE_FORMAT = 'DD MMM YYYY',
  SIMPLE_DATE_TIME_FORMAT = 'DD MMM YYYY h:mm:ss',
  GRAPHQL_FORMAT = 'YYYY-MM-DD',
  FULL_DAY_FORMAT = 'ddd, MMM DD YYYY H:mm',
  CUSTOM_HISTORY_FORMAT = 'DD MMM YYYY - H:mm',
  FULL_DATE_TIME_FORMAT = 'DD MMMM YYYY h:mm:ss',
  SIMPLE_FULL_DATE_FORMAT = 'DD MMMM YYYY',
  TIME_FORMAT = 'H:mm',
  SIMPLE_FULL_DAY_FORMAT = 'ddd, DD MMMM YYYY H:mm',
}

export const formatDate = (date: Date, format: DateFormat) => {
  return moment(new Date(date)).format(format)
}
